Vue.component('frame', {
    template: `
        <div id="frame">

            <iframe :src="urls[frame]" frameborder="0" @load="onLoadFrame()"></iframe>

        </div>
    `,
    data: function() {
        return {

        };
    },

    computed: {

        fn() {
            return this.$store.getters.fn;
        },

        frame() {
            return this.$store.getters.currentFrame;
        },

        urls() {
            return {
                priority:       this.$setupPath + '../legal/public/index.php?id=' + this.fn + '&page=prioritymap',
                table:          this.$setupPath + '../legal/public/index.php?id=' + this.fn + '&page=table',
                timeline:       this.$setupPath + '../legal/public/index.php?id=' + this.fn + '&page=index',
                reassignments:  this.$setupPath + '../legal/public/index.php?id=' + this.fn + '&page=reassignments',
                assignees:      this.$setupPath + '../pubDetails/public/index.php?fn=' + this.fn + '&show=assignees',
                agents:         this.$setupPath + '../pubDetails/public/index.php?fn=' + this.fn + '&show=agents',
                inventors:      this.$setupPath + '../pubDetails/public/index.php?fn=' + this.fn + '&show=inventors',
                examiners:      this.$setupPath + '../pubDetails/public/index.php?fn=' + this.fn + '&show=examiners'
            };
        }
    },

    methods: {
        onLoadFrame() {
            EventBus.$emit('HIDE_LOADING');
        }
    }
});
